import { Injectable } from '@angular/core';
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbToastrService
} from '@nebular/theme';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastrService: NbToastrService) {}

  showToast(
    type: ToastType,
    title: string,
    body: string,
    icon:string = ''
  ) {
    let status: NbComponentStatus;
    switch (type) {
      case 'success':
        status = 'success';
        if(icon.length === 0) icon = 'checkmark-outline';
        break;
      case 'error':
        status = 'danger';
        if(icon.length === 0) icon = 'close-outline';
        break;
      case 'warning':
        status = 'warning';
        if(icon.length === 0) icon = 'alert-triangle-outline';
        break;
      default:
        status = 'info';
        if(icon.length === 0) icon = 'info-outline';
    }

    const config = {
      status: status,
      destroyByClick: false,
      duration: 4000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: true,
      icon: icon,
      pack: 'eva'
    };

    this.toastrService.show(body, title, config);
  }
}
